// SI-Inspiration content lock 2026-05-11 (Sebastian Gate-1).
// Replaces the prior 3-item Mai-Launch list with the 10-item
// post-launch content set. No backend tracking, no personalization
// — flat list shown to every user.

export interface FeatureDiscoveryItem {
  /** Stable slug for React keys + tests. */
  id: string;
  /** Lead emoji rendered above the title. */
  emoji: string;
  /** Card title — short noun-phrase. */
  title: string;
  /** Body copy — em-dashes preserved verbatim from prompt. */
  body: string;
}

export const FEATURE_DISCOVERY_ITEMS: readonly FeatureDiscoveryItem[] = [
  {
    id: 'audio-geschichten',
    emoji: '🎵',
    title: 'Audio-Geschichten',
    body: 'Jede Geschichte gibt es auch zum Anhören — Audio kannst du beim Erstellen aktivieren, perfekt fürs Auto, unterwegs oder zum Einschlafen.',
  },
  {
    id: 'sb-wow-fakten',
    emoji: '🦊',
    title: 'Schlauberger: Wow-Fakten',
    body: 'Wusstest du, dass Schlauberger-Geschichten echte Fakten und Experimente enthalten?',
  },
  {
    id: 'favoriten',
    emoji: '⭐',
    title: 'Favoriten markieren',
    body: 'Markiere Lieblingsgeschichten mit dem Stern — finde sie schnell in der Bibliothek wieder.',
  },
  {
    id: 'echte-app',
    emoji: '📱',
    title: 'Wie eine echte App nutzen',
    body: 'Add to Homescreen: tippe auf "Teilen" → "Zum Home-Bildschirm" → Dreamable startet wie jede andere App, ohne URL-Zeile und voller Bildschirm.',
  },
  {
    id: 'bluetooth',
    emoji: '🔊',
    title: 'Per Bluetooth-Lautsprecher hören',
    body: 'Geschichten laufen über jeden Bluetooth-Lautsprecher — perfekt für den Raum, fürs Auto, für alle Mitfahrer und Mit-Hörer.',
  },
  {
    id: 'mehrere-kinder',
    emoji: '👨‍👩‍👧‍👦',
    title: 'Mehrere Kinder im Profil',
    body: 'Du kannst pro Account mehrere Kinder anlegen (z.B. Geschwister) und bei der Geschichten-Erstellung auswählen, welches Kind im Mittelpunkt steht.',
  },
  {
    id: 'heldenchronik',
    emoji: '📜',
    title: 'Heldenchronik',
    body: 'Eure erlebten Welten im Überblick — pro Kind ein eigener Fortschritt vom Forscher bis zum Helden.',
  },
  {
    id: 'account-uebersicht',
    emoji: '🔍',
    title: 'Account-Übersicht',
    body: 'Schau unter Account nach, welches Abo du hast, wie viele Geschichten dir diesen Monat zur Verfügung stehen und welche Welten freigeschaltet sind.',
  },
  {
    id: 'pdf-download',
    emoji: '📄',
    title: 'PDF-Version herunterladen',
    body: 'Lade jede Geschichte als illustrierte PDF herunter — zum Ausdrucken, zum Verschenken oder als Erinnerung.',
  },
  {
    id: 'zufallsgeschichte',
    emoji: '🎲',
    title: 'Zufallsgeschichte',
    body: 'Keine Zeit zum Beschreiben? Wir erstellen für eure Welt eine passende Geschichte — du wählst nur, in welcher Welt es spielen soll.',
  },
] as const;
